import { createRouter, RouterProvider } from '@tanstack/react-router';

import { QueryProvider } from '@repo/query';

import { queryClient } from '@/lib/query-client';
import { routeTree } from '@/routeTree.gen';
import '@/styles/globals.css';
import ReactDOM from 'react-dom/client';
import type { IconType } from '@repo/ui';

// Set up a Router instance
const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  defaultViewTransition: true,
});

// Register things for typesafety
declare module '@tanstack/react-router' {
  interface StaticDataRouteOption {
    title?: string;
    icon?: IconType;
  }
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Missing #root element in index.html');

if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <QueryProvider client={queryClient} showDevtools={import.meta.env.DEV}>
      <RouterProvider router={router} />
    </QueryProvider>,
  );
}
